<template>
  <div class="w-full flex space-x-4">
    <Field v-slot="{ handleChange }" :id="name" :name="name" type="checkbox">
      <Checkbox
        v-model:modelValue="value"
        :name="name"
        :inputId="name"
        :disabled="disabled"
        :binary="binary"
        @update:modelValue="handleChange"
      />
    </Field>
    <label :for="name" class="ml-2">{{ label }}</label>
  </div>
  <ErrorMessage class="text-red-600" :name="name" />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Field, ErrorMessage, useFieldValue } from 'vee-validate'
import Checkbox from 'primevue/checkbox'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  binary: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const initialValue = useFieldValue(props.name)

const value = ref(initialValue.value)
</script>
